import statusFilter from './options/status';
import shipDateFilter from './options/ship-date';
import createDateFilter from './options/create-date';

export const allFilterBys = [statusFilter, shipDateFilter, createDateFilter];

export const popularFilterBys = [statusFilter, shipDateFilter, createDateFilter];
